import React, { useState } from "react";
import {
  makeStyles,
  Grid,
  Typography,
  Button,
  Hidden,
} from "@material-ui/core";
import ContainerMain from "./reusableComponents/ContainerMain";
import { Image } from "semantic-ui-react";
import './style.css'
import CollabImg from '../assets/images/f_1.svg'
import IntelligentImg from '../assets/images/f_2.svg'
import IntegratedImg from '../assets/images/f_3.svg'
import RealTimeImg from '../assets/images/f_4.svg'


{/* <Grid item xs={8} className={classes.infoContainer}>
           
            <Grid className={classes.padding}>
              <Typography className={classes.infoTypo}>
                Collaborate with us
              </Typography>
              <Typography className={classes.infoSubTypo}>
              Keep a tab on all the activities and information of the borrower on one central platform. With CollectEaze, you'll improve collector proficiency while keeping costs low
              </Typography>
              <ul>
                <li className={classes.infoSubTypo}>
                  Ipsum dolor sit amet, consetetur
                </li>
                <li className={classes.infoSubTypo}>
                  Lorem ipsum dolor sit amet
                </li>
                <li className={classes.infoSubTypo}>Lorem ipsum dolor sit</li>
                <li className={classes.infoSubTypo}>
                  dolor sit amet, consetetur
                </li>
              </ul>
              <Grid className={classes.buttonFlex}>
                <Button
                  variant="contained"
                  color="primary"
                  className={classes.buttonField}
                >
                  Know More
                </Button>
                <Button variant="contained" className={classes.buttonField2}>
                  Explore All Features
                </Button>
              </Grid>
            </Grid>
           
          </Grid> */}



const useStyles = makeStyles((theme) => ({
  container: {
    padding: "50px 180px 50px 180px",
    [theme.breakpoints.down("xs")]: {
      textAlign: "center",
      justifyContent: "center",
      padding: 20,
    },
  },
  qaMain: {
    color: theme.palette.tertiary.main,
    fontWeight: 700,
    fontSize: "25px",
    display: "flex",
    justifyContent: "space-evenly",
    alignItems: "center",
  },
  qaSub: {
    color: theme.palette.text.main,
    fontWeight: 300,
    fontSize: "15px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    padding: "10px 0px 10px 0px",
    textAlign: "center",
  },
  gridContainer: {
    padding: 10,
    [theme.breakpoints.down("md")]: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      padding: 0,
    },
  },
  typo: {
    marginLeft: 15,
    fontWeight: 500,
    fontSize: 18,
    [theme.breakpoints.down("md")]: {
      fontSize: 12,
    },
  },
  flex: {
    display: "flex",
    justifyContent: "space-evenly",
    alignItems: "center",
    padding: 10,
    cursor: "pointer",
  },
  image: {
    height: 35,
    width: 35,
    [theme.breakpoints.down("md")]: {
      height: 20,
      width: 20,
    },
  },
  arrowMargin: {
    marginLeft: 5,
    fontSize: 20,
    color: theme.palette.primary.main,
    fontWeight: 700,
  },
  infoContainer: {
    borderLeft: "1px solid",
    borderColor: "rgba(112,112,112,0.15)",
    [theme.breakpoints.down("md")]: {
      border: "none",
    },
  },
  infoTypo: {
    color: theme.palette.primary.main,
    fontWeight: 500,
    fontSize: 18,
    paddingTop: 10,
  },
  infoSubTypo: {
    color: theme.palette.text.main,
    fontWeight: 300,
    fontSize: 12,
    paddingTop: 10,
  },
  padding: {
    padding: "10px 0px 0px 25px",
  },
  buttonFlex: {
    display: "flex",
    [theme.breakpoints.down("md")]: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      padding: 0,
    },
  },
  buttonField: {
    color: theme.palette.defaultWhite.main,
    borderRadius: "3px",
    fontSize: "10px",
    padding: "8px 30px 8px 30px",
    [theme.breakpoints.down("md")]: {
      padding: "8px 35px 8px 35px",
    },
    "&:hover": {
      background: theme.palette.primary.main,
    },
    textTransform: "none",
    boxShadow: "none",
  },
  buttonField2: {
    marginLeft: 20,
    [theme.breakpoints.down("md")]: {
      marginLeft: 0,
      marginTop: 5,
    },
    boxShadow: "none",
    color: theme.palette.text.main,
    background: theme.palette.defaultWhite.main,
    borderRadius: "3px",
    fontSize: "10px",
    padding: "8px 15px 8px 15px",
    "&:hover": {
      background: theme.palette.primary.main,
      color: theme.palette.defaultWhite.main,
    },
    textTransform: "none",
  },
  smallerGrid: {
    [theme.breakpoints.down("md")]: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      padding: 5,
    },
  },
}));

const Features = () => {


  const OnlineCollaboration = () => {
    return <div className="hihello">
      <Grid item xs={8} className={`Feature-container ${classes.infoContainer}`}>

        <Grid className={classes.padding}>
          <Typography className={classes.infoTypo}>
            Collaborate with us
          </Typography>
          <Typography className={classes.infoSubTypo}>
            Keep a tab on all the activities and information of the borrower on one central platform. With CollectEaze, you'll improve collector proficiency while keeping costs low
          </Typography>
          <ul>
            <li className={classes.infoSubTypo}>
              Centralised Dashboard
            </li>
            <li className={classes.infoSubTypo}>
              360° overview
            </li>
            <li className={classes.infoSubTypo}>
              Cheap operation costs
            </li>
            <li className={classes.infoSubTypo}>
              Constant monitoring of borrowers' profiles
            </li>
          </ul>
          <Grid className={`Feature-Buttons ${classes.buttonFlex}`}>
            <Button
              variant="contained"
              color="primary"
              className={classes.buttonField}
            >
              Know More
            </Button>
            <Button variant="contained" className={classes.buttonField2}>
              Explore All Features
            </Button>
          </Grid>
        </Grid>

      </Grid>
    </div>
  }



  const IntelligentCollections = () => {
    return <div>
      <Grid item xs={8} className={classes.infoContainer}>

        <Grid className={classes.padding}>
          <Typography className={classes.infoTypo}>
            Collaborate with us
          </Typography>
          <Typography className={classes.infoSubTypo}>
            Strengthen your collection process with the help of our automated software. Get a detailed analysis about your collection performance and keep a check on your team's productivity.
          </Typography>
          <ul>
            <li className={classes.infoSubTypo}>
              Automated Collection process
            </li>
            <li className={classes.infoSubTypo}>
              Fast settlement
            </li>
            <li className={classes.infoSubTypo}>High efficiency</li>
            <li className={classes.infoSubTypo}>
              Smoother workflow of debt recovery
            </li>
          </ul>
          <Grid className={classes.buttonFlex}>
            <Button
              variant="contained"
              color="primary"
              className={classes.buttonField}
            >
              Know More
            </Button>
            <Button variant="contained" className={classes.buttonField2}>
              Explore All Features
            </Button>
          </Grid>
        </Grid>

      </Grid>
    </div>
  }





  const IntegratedPayments = () => {
    return <div>
      <Grid item xs={8} className={classes.infoContainer}>

        <Grid className={classes.padding}>
          <Typography className={classes.infoTypo}>
            Collaborate with us
          </Typography>
          <Typography className={classes.infoSubTypo}>
            Ensuring seamless cash flow and improved DSO with an auto-generated on-time payment invoice.
          </Typography>
          <ul>
            <li className={classes.infoSubTypo}>
              Real-time reconciliation
            </li>
            <li className={classes.infoSubTypo}>
              Automated payment requests
            </li>
            <li className={classes.infoSubTypo}>Highly secured multiple payment gateways</li>
            {/* <li className={classes.infoSubTypo}>
              dolor sit amet, consetetur
            </li> */}
          </ul>
          <Grid className={classes.buttonFlex}>
            <Button
              variant="contained"
              color="primary"
              className={classes.buttonField}
            >
              Know More
            </Button>
            <Button variant="contained" className={classes.buttonField2}>
              Explore All Features
            </Button>
          </Grid>
        </Grid>

      </Grid>
    </div>
  }





  const RealTimeAnalytics = () => {
    return <div>
      <Grid item xs={8} className={classes.infoContainer}>

        <Grid className={classes.padding}>
          <Typography className={classes.infoTypo}>
            Collaborate with us
          </Typography>
          <Typography className={classes.infoSubTypo}>
            Increased visibility of your borrowers' profile lets you gain insight into their current performance and a prediction of future cash flow.
          </Typography>
          <ul>
            <li className={classes.infoSubTypo}>
              Detailed and customisable reports
            </li>
            <li className={classes.infoSubTypo}>
              Fast deliveries
            </li>
            <li className={classes.infoSubTypo}>AI-based recovery model</li>
            {/* <li className={classes.infoSubTypo}>
              dolor sit amet, consetetur
            </li> */}
          </ul>
          <Grid className={classes.buttonFlex}>
            <Button
              variant="contained"
              color="primary"
              className={classes.buttonField}
            >
              Know More
            </Button>
            <Button variant="contained" className={classes.buttonField2}>
              Explore All Features
            </Button>
          </Grid>
        </Grid>

      </Grid>
    </div>
  }






  const classes = useStyles();
  const [select, setSelect] = React.useState(1);
  const [Show, setShow] = useState("OnlineCollaboration")

  // const onSelect = (e) => {
  //   let a = e.target.getAttribute("value")
  //   console.log(a)
  // };
  const handleChange = (e) => {
    // setShow(e.target.value)
    let a = e.currentTarget.getAttribute("value")
    setShow(a);
    console.log(a);

  }

  return (
    <ContainerMain>
      <Grid className={`CollectEazeFeatures ${classes.container}`}>
        <Grid className={`Feature-Head ${classes.qaMain}`}>CollectEaze Features</Grid>
        <Grid className={`Align-Left ${classes.qaSub}`}>
          From managing on-time payments  to monitoring and reaching out to debtors. All your work can be done on a single platform making your tasks simpler and adding  efficiency to your collections.
        </Grid>
        <Grid container className={`Feature-Section ${classes.gridContainer}`}>
          <Grid item xs={4} className={`Feature-Scroll ${classes.smallerGrid}`}>
            <Grid
              value="OnlineCollaboration"
              className={`Feature-Name ${classes.flex}`}
              container
              onClick={handleChange}
            >
              <Grid item xs={2}>
                <img src={CollabImg} className={classes.image} />
              </Grid>
              <Grid item xs={9} className="hihello2">
                <Typography className={`Feature-text ${classes.typo}`}>
                  Online Collaboration
                </Typography>
              </Grid>
              <Hidden smDown>
                {Show === "OnlineCollaboration" ? (
                  <Grid item xs={1}>
                    <Typography className={classes.arrowMargin}>
                      {">"}
                    </Typography>
                  </Grid>
                ) : (
                  <Grid item xs={1} />
                )}
              </Hidden>
            </Grid>
            <Grid
              value="IntelligentCollections"
              className={`Feature-Name ${classes.flex}`}
              container
              onClick={handleChange}
            >
              <Grid item xs={2}>
                <img src={IntelligentImg} className={classes.image} />
              </Grid>
              <Grid item xs={9}>
                <Typography className={classes.typo}>
                  Intelligent Collections
                </Typography>
              </Grid>
              <Hidden smDown>
                {Show === "IntelligentCollections" ? (
                  <Grid item xs={1}>
                    <Typography className={classes.arrowMargin}>
                      {">"}
                    </Typography>
                  </Grid>
                ) : (
                  <Grid item xs={1} />
                )}
              </Hidden>
            </Grid>
            <Grid
              value="IntegratedPayments"
              className={`Feature-Name ${classes.flex}`}
              container
              onClick={handleChange}
            >
              <Grid item xs={2}>
                <img src={IntegratedImg} className={classes.image} />
              </Grid>
              <Grid item xs={9}>
                <Typography className={classes.typo}>
                  Integrated Payments
                </Typography>
              </Grid>
              <Hidden smDown>
                {Show === "IntegratedPayments" ? (
                  <Grid item xs={1}>
                    <Typography className={classes.arrowMargin}>
                      {">"}
                    </Typography>
                  </Grid>
                ) : (
                  <Grid item xs={1} />
                )}
              </Hidden>
            </Grid>
            <Grid
              value="RealTimeAnalytics"
              className={`Feature-Name ${classes.flex}`}
              container
              onClick={handleChange}
            >
              <Grid item xs={2}>
                <img src={RealTimeImg} className={classes.image} />
              </Grid>
              <Grid item xs={9}>
                <Typography className={classes.typo}>
                  Real-Time Analytics
                </Typography>
              </Grid>
              <Hidden smDown>
                {Show === "RealTimeAnalytics" ? (
                  <Grid item xs={1}>
                    <Typography className={classes.arrowMargin}>
                      {">"}
                    </Typography>
                  </Grid>
                ) : (
                  <Grid item xs={1} />
                )}
              </Hidden>
            </Grid>
          </Grid>
          <div>{Show === 'OnlineCollaboration' ? <OnlineCollaboration /> : Show === 'IntelligentCollections' ? <IntelligentCollections /> : Show === 'IntegratedPayments' ? <IntegratedPayments /> : Show === 'RealTimeAnalytics' ? <RealTimeAnalytics /> : false}</div>

        </Grid>
      </Grid>
    </ContainerMain>
  );
};

export default Features;
